(function () {
  if (typeof window.CustomEvent === "function") return false; //If not IE

  function CustomEvent(event, params) {
    params = params || {
      bubbles: false,
      cancelable: false,
      detail: undefined
    };
    var evt = document.createEvent('CustomEvent');
    evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
    return evt;
  }

  CustomEvent.prototype = window.Event.prototype;
  window.CustomEvent = CustomEvent;
})();

/**
 * Store commonly used global elements.
 * -----------------------------------------------------------------------------
 */

// body, header, & footer elements are added after document loaded
theme.cached = {
  $document: $(document),
  $window: $(window)
};

// Store some globals
window.RS = window.RS || {};
window.RS.variables = window.RS.variables || {};

theme.LOG = theme.LOG || (function() {
  var log = function(params) {
    var body = {
      'level': params.level ? params.level : 1,
      '_application': params['_application'] ? params['_application'] : 'default',
      'full_message': params['full_message'] ? params['full_message'] : 'No input'
    };
    fetch('https://logs.roswellstudios.com/gelf', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(body)
    })
      .then(response => response.json())
      .then(data => console.log('RS:Log:', data));
  };
  return {
    log: log
  };
})();

/**
 * initCachedElems
 * @summary Add elements to the cachedElems object.
 * @param {Object} selectors - jQuery element selectors
 * @param {Object} $container - A DOM Element, Document, or jQuery to use as context
 * @param {Object} cachedElems - object where elements are stored
 * @returns {Undefined}
 */
theme.initCachedElems = function(selectors = {}, $container, cachedElems) {
  var cached = cachedElems ? cachedElems : {};
  var keys = Object.keys(selectors);
  keys.forEach(function(key) {
    var $elem = $(selectors[key], $container);
    cachedElems['$' + key] = $elem;
  });

  return cached;
};

/*
* debounce
* @method
* @summary Returns a function, that, as long as it continues to be invoked, will not
*   be triggered. The function will be called after it stops being called for
*   N milliseconds. If `immediate` is passed, trigger the function on the
*   leading edge, instead of the trailing.
*
* @param {Object} func - function to debounce
* @param {Number} wait - time in ms to delay the function call. Passed to setTimeout
* @param {Boolean} immediate - should function get called immediately
* @return {Object} new function set in a setTimeout
*/
theme.debounce = function debounce(func, wait, immediate) {
  var timeout;
  return function () {
    var context = this,
      args = arguments;

    var later = function later() {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };

    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
};

/**
 * Adds a Shopify size attribute to a URL
 *
 * @param src
 * @param size
 * @returns {*}
 */
theme.getSizedImageUrl = function(src, size, removeProtocol) {
  var finalSrc = src;

  if (size === null) {
    return finalSrc;
  }

  if (size !== 'master') {
    // return theme.removeProtocol(src);
    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      finalSrc = prefix[0] + '_' + size + suffix;
    }

  }

  if (removeProtocol) finalSrc = theme.removeProtocol(finalSrc);

  return finalSrc;
}

theme.removeProtocol = function(path) {
  return path.replace(/http(s)?:/, '');
}

theme.handelize = function (str) {

  if ( typeof str != 'string' || str == "" ) {
    return ""; // should probably return an informative error
  }

  str = str.toLowerCase();
  var toRemoveEnd = ['"',  "'", "\\", "(", ")", "[", "]", ".", "-"];
  var toReplace = [ "'", "\\", "(", ")", "[", "]", "."];
  var toRemove = ['"'];
  const strLength = str.length;

  // For the old browsers
  for (var i = 0; i < toReplace.length; ++i) {
    str = str.replace(toReplace[i], "-");
  }
  for (var i = 0; i < toRemoveEnd.length; ++i) {
    if(str.charAt(strLength - 1) ==  toRemoveEnd[i]){
      str = str.substring(0, str.length - 1);
    }
    if(str.charAt(0) == toRemoveEnd[i]){
      str = str.slice(1)
    }
  }
  for (var i = 0; i < toRemove.length; ++i) {
    str = str.replace(toRemove[i], "");
  }

  str = str.replace(/\W+/g, "-");
  if (str.charAt(str.length - 1) == "-") {
    str = str.replace(/-+\z/, "");
  }
  if (str.charAt(0) == "-") {
    str = str.replace(/\A-+/, "");
  }

  if ( !isNaN( str.charAt(0) ) ) {
    str = 'n'.concat(str);
  }

  return str
}

theme.serializeQuery = function(params, prefix) {
  var query = Object.keys(params).map((key) => {
    var value  = params[key];

    if (params.constructor === Array)
      key = `${prefix}[]`;
    else if (params.constructor === Object)
      key = (prefix ? `${prefix}[${key}]` : key);

    if (typeof value === 'object')
      return serializeQuery(value, key);
    else
      return `${key}=${encodeURIComponent(value)}`;
  });

  return [].concat.apply([], query).join('&');
};

/**
 * Add or update a query string parameter. If no URI is given, we use the current
 * window.location.href value for the URI.
 *
 * Based on the DOM URL parser described here:
 * http://james.padolsey.com/javascript/parsing-urls-with-the-dom/
 *
 * @param {String} uri - Optional: The URI to add or update a parameter in
 * @param {String} key - The key to add or update
 * @param {String} value - The new value to set for key
 *
 * Tested on Chrome 34, Firefox 29, IE 7 and 11
 *
 * Source:
 * https://stackoverflow.com/questions/5999118/how-can-i-add-or-update-a-query-string-parameter/23529943#23529943
 */
theme.updateQueryString = function updateQueryString( uri, key, value ) {

  // Use window URL if no query string is provided
  if ( ! uri ) { uri = window.location.href; }

  // Create a dummy element to parse the URI with
  var a = document.createElement( 'a' ),

    // match the key, optional square brackets, an equals sign or end of string, the optional value
    reg_ex = new RegExp( key + '((?:\\[[^\\]]*\\])?)(=|$)(.*)' ),

    // Setup some additional variables
    qs,
    qs_len,
    key_found = false;

  if (typeof value === 'string') {
    value = value.trim();
  } else if (value === undefined || value === null) {
    value = '';
  }

  // Use the JS API to parse the URI
  a.href = uri;

  // If the URI doesn't have a query string, add it and return
  if ( ! a.search ) {

    if (value !== '') {
      a.search = '?' + key + '=' + value;
    }
    return a.href;
  }

  // Split the query string by ampersands
  qs = a.search.replace( /^\?/, '' ).split( /&(?:amp;)?/ );
  qs_len = qs.length;

  // Loop through each query string part
  while ( qs_len > 0 ) {

    qs_len--;

    // Remove empty elements to prevent double ampersands
    if ( ! qs[qs_len] ) { qs.splice(qs_len, 1); continue; }

    // Check if the current part matches our key
    if ( reg_ex.test( qs[qs_len] ) ) {

      if (value !== '') {
        // Replace the current value
        qs[qs_len] = qs[qs_len].replace( reg_ex, key + '$1' ) + '=' + value;
      } else {
        qs[qs_len] = qs[qs_len].replace( reg_ex, '');
      }

      key_found = true;
    }
  }

  // If we haven't replaced any occurrences above, add the new parameter and value
  if ( ! key_found && value !== '') { qs.push( key + '=' + value ); }

  qs = qs.filter(function(query) {
    return query !== '';
  });

  if (qs.length) {

    if (qs.length > 1) {
      // Set the new query string
      a.search = '?' + qs.join( '&' );
    } else {
      a.search = '?' + qs.join( '' );
    }
  }


  return a.href;
};

/**
 * Builds object from query string
 * @param {String} query - Optional: The url search parameters
 * @returns {Object}
 *
 * Source:
 * https://stackoverflow.com/questions/901115/how-can-i-get-query-string-values-in-javascript/2880929#2880929
 */
theme.getUrlParams = function getUrlParams(query) {
  var match,
    urlParams = {},
    pl = /\+/g,  // Regex for replacing addition symbol with a space
    search = /([^&=]+)=?([^&]*)/g,
    decode = function (s) {
      return decodeURIComponent(s.replace(pl, " "));
    };

  if (!query) {
    query = window.location.search.substring(1);
  }

  while (match = search.exec(query)) {
    if (decode(match[1]) in urlParams) {
      if (!Array.isArray(urlParams[decode(match[1])])) {
        urlParams[decode(match[1])] = [urlParams[decode(match[1])]];
      }
      urlParams[decode(match[1])].push(decode(match[2]));
    } else {
      urlParams[decode(match[1])] = decode(match[2]);
    }
  }

  return urlParams;
}

/**
 * Checks response status. Necessary to handle Fetch repsonse behavior.
 * @param {Array} records - Response records.
 * @return {Promise<Array>} If success, a Promise of parsed response as
 * JSON. If error, throws Error object with the status text.
 */
theme.verifyFetchResponseStatus = function verifyFetchResponseStatus(response) {
  var resp = response || {};
  var status = resp.status;
  var statusText = resp.statusText;

  if (status) {
    if (status >= 200 && status < 300) {
      return resp.json();
    } else {
      throw Error(statusText);
    }
  }

  return resp;
};

theme.RSExtAppApi = (function() {
  var ROUTE = "/graphql/v1";
  var ROUTE_V2 = "/graphql/v2";
  var myHeaders = new Headers();
  var defaultRequestOptions = {
    headers: myHeaders,
    redirect: 'follow'
  };
  var endpointOptions = {
    addOption: {
      queryStr: 'mutation ($input: OptionsInput! ){' +
        'addOption ( input: $input) {' +
        'id\n' +
        'dataSource\n' +
        'preview' +
        '}' +
        '}',
      variables: function(variables) {
        return {
          "input": {
            "path": variables.path,
            "themeId": variables.themeId,
            "dataSource": variables.inputValue,
            "selector": variables.selector,
            "viewportWidth": variables.viewportWidth,
            "viewportHeight": variables.viewportHeight
          }
        }
      }
    },
    getOptionById: {
      queryStr: 'query ($input: String! ){' +
        'getOption (id: $input) {' +
        'id\n' +
        'dataSource\n' +
        'preview' +
        '}' +
        '}',
      variables: function(variables) {
        return { "input": variables.inputValue };
      }
    },
    getOptionDataById: {
      queryStr: 'query ($input: String! ){' +
        'getOption (id: $input) {' +
        'id\n' +
        'dataSource\n' +
        '}' +
        '}',
      variables: function(variables) {
        return { "input": variables.inputValue };
      }
    },
    getOptions: {
      queryStr: 'query {' +
        'getOptions {' +
        'id' +
        '}' +
        '}'
    }
  }

  myHeaders.append("Content-Type", "application/json");

  function query(options, successCb, errorCb, route) {
    // Apologies for mixing jQuery with native. Using jQuery to return promise
    // for now. Once Adina wrapped in Vue, we can covert to use native ES6.
    var $deferred = new $.Deferred();
    var newRoute = route ? route : ROUTE;
    var uri = theme.rsExternalAppUrl + newRoute;

    fetch(uri, options)
      .then(theme.verifyFetchResponseStatus)
      .then(function(result) {
        $deferred.resolve(result);
      })
      .catch(function(error) {
        $deferred.reject(error);
      });

    return $deferred.promise();
  }

  function getEndpointOptions(endpoint, variables) {
    var graphql = {};
    if (endpointOptions[endpoint]) {
      if (endpointOptions[endpoint].queryStr) {
        graphql.query = endpointOptions[endpoint].queryStr;
      }
      if (endpointOptions[endpoint].variables) {
        graphql.variables = endpointOptions[endpoint].variables(variables);
      }
    }
    return JSON.stringify(graphql);
  }

  function addOption(variables, successCb, errorCb) {
    var requestOptions = defaultRequestOptions || {};
    requestOptions.method = 'POST';
    requestOptions.body = getEndpointOptions('addOption', variables);
    return query(requestOptions, successCb, errorCb);
  }

  function getOptionById(variables, successCb, errorCb) {
    var requestOptions = defaultRequestOptions || {};
    requestOptions.method = 'POST';
    requestOptions.body = getEndpointOptions('getOptionById', variables);
    return query(requestOptions, successCb, errorCb);
  }

  function getOptions(successCb, errorCb) {
    var requestOptions = defaultRequestOptions || {};
    requestOptions.method = 'POST';
    requestOptions.body = getEndpointOptions('getOptions');
    return query(requestOptions, successCb, errorCb);
  }

  function queryV2( action, variables, successCb, errorCb) {
    var requestOptions = defaultRequestOptions || {};
    requestOptions.method = 'POST';
    requestOptions.body = getEndpointOptions(action, variables);
    return query(requestOptions, successCb, errorCb, ROUTE_V2);
  }

  return {
    query: query,
    v1: {
      addOption: addOption,
      getOptionById: getOptionById,
      getOptions: getOptions
    },
    v2: {
      addOption: function(variables) {
        return queryV2('addOption', variables);
      },
      getOptionById: function(variables) {
        return queryV2('getOptionById', variables);
      },
      getOptionDataById: function(variables) {
        return queryV2('getOptionDataById', variables);
      },
      getOptions: function() {
        return queryV2('getOptions');
      }
    }
  }
})();

theme.RS = theme.RS || {};

theme.RS.OffsetHeader = (function() {
  var BREAKPOINT_DESKTOP = 768;
  var selectors = new Set();
  var curWidth = theme.cached.$window.width();
  var debounceOffsetHeader = theme.debounce(function($elem) {
    var newWidth = theme.cached.$window.width();
    if (curWidth !== newWidth) {
      offsetHeader($elem);
      curWidth = newWidth;
    }
  }, 500);

  function offsetHeader($headerOffsetElem) {
    var headerContentHeight, totalHeight, $transparentHeader;
    var isMobile = curWidth < BREAKPOINT_DESKTOP;

    if ($headerOffsetElem && $headerOffsetElem.length) {
      var totalHeight = window.RS.Helpers.getHeaderHeight();

      if (!isNaN(totalHeight)) {
        $transparentHeader = theme.cached.$document.find('.header-transparent').first();
        if ($transparentHeader) {
          if (
            (isMobile && $transparentHeader.attr('data-transparent-mobile'))
            || (!isMobile && $transparentHeader.attr('data-transparent'))
          ) {
            totalHeight = 0;
          }
        }
        $headerOffsetElem.css('padding-top', totalHeight + 'px');
        var offsetEvent = new CustomEvent(
          'RS:headerOffset',
          {
            detail: {
              offsetVal: totalHeight,
              headerHeight: headerContentHeight
            }
          }
        );
        document.dispatchEvent(offsetEvent);
      }
    }
  }

  function initOffsetHeader(selector) {
    var $headerOffsetElem = selector ? $(selector) : null;

    if ($headerOffsetElem && $headerOffsetElem.length) {
      if (!selectors.has(selector)) {
        selectors.add(selector);
        offsetHeader($headerOffsetElem.first());

        theme.cached.$window.on('resize', function() {
          debounceOffsetHeader($headerOffsetElem);
        });
      }
    }
  }

  return {
    initOffsetHeader: initOffsetHeader,
    offsetHeader: offsetHeader
  };
})();

theme.RS.HeaderScroll = (function() {
  var SCROLLED_CLASS = 'header--scrolled';

  var onScrollHandler = function() {
    if (window.scrollY > 50) {
      theme.cached.$header.addClass(SCROLLED_CLASS);
    } else {
      theme.cached.$header.removeClass(SCROLLED_CLASS);
    }
  };
  var init = function() {
    theme.cached.$window.on('scroll', onScrollHandler);
  }
  return {
    init: init
  }
})();

theme.RS.OffsetTransparentHeader = (function() {
  var BREAKPOINT_DESKTOP = 768;
  var TRANSPARENT_DESKTOP = 'header-transparent--desktop';
  var TRANSPARENT_MOBILE = 'header-transparent--mobile';
  var curWidth = theme.cached.$window.width();
  var isTransparent = false;

  var debounceOffsetHeader = theme.debounce(function() {
    toggleTransparentHeader();
  }, 500);

  function setTransparentOffsets() {
    var $transparentHeaders = theme.cached.$document.find('.header-transparent');
    var curHeight = window.RS.Helpers.getHeaderHeight();
    var isMobile = curWidth < BREAKPOINT_DESKTOP;
    isTransparent = $transparentHeaders.length ? true : false;

    if (isTransparent) {
      $transparentHeaders.on('mouseenter', onMouseEnter);
      $transparentHeaders.on('mouseleave', onMouseLeave);
    }

    if (!isNaN(curHeight) && isTransparent) {
      $transparentHeaders.each(function() {
        var $this = $(this);
        var offset = '';

        if (
          (isMobile && $this.attr('data-transparent-mobile'))
          || (!isMobile && $this.attr('data-transparent'))
        ) {
          offset = curHeight;

          if (isMobile) {
            $this.addClass(TRANSPARENT_MOBILE);
            $this.removeClass(TRANSPARENT_DESKTOP);
          } else {
            $this.addClass(TRANSPARENT_DESKTOP);
            $this.removeClass(TRANSPARENT_MOBILE);
          }
        }

        if (offset) {
          offset = '-' + offset + 'px';
        }

        $this.css('margin-bottom', offset);
      });
    }
  }

  function onMouseEnter() {
    var $transparentHeaders = theme.cached.$document.find('.header-transparent');
    if (isTransparent) {
      $transparentHeaders.removeClass(TRANSPARENT_DESKTOP);
      $transparentHeaders.removeClass(TRANSPARENT_MOBILE);
    }
  }

  function onMouseLeave() {
    if (isTransparent) {
      toggleTransparentHeader();
    }
  }

  function toggleTransparentHeader() {
    var $transparentHeaders = theme.cached.$document.find('.header-transparent');
    if (isTransparent && $transparentHeaders.length) {
      if (window.scrollY > 50) {
        $transparentHeaders.removeClass(TRANSPARENT_DESKTOP);
        $transparentHeaders.removeClass(TRANSPARENT_MOBILE);
      } else {
        setTransparentOffsets();
      }
    }
  }

  function init() {
    setTransparentOffsets();
    theme.cached.$window.on('resize', function() {
      debounceOffsetHeader();
    });
    theme.cached.$window.on('scroll', toggleTransparentHeader);
  }

  return {
    init: init
  }
})();

/**
 * forceFullWidth
 * @summary Add elements to the cachedElems object.
 * @returns {Object} function
 */
theme.RS.ForceFullWidth = (function() {
  var curWidth = theme.cached.$window.width();
  var debounceForceFullWidth = theme.debounce(function($elem) {
    var newWidth = theme.cached.$window.width();
    if (curWidth !== newWidth) {
      forceFullWidth($elem);
      curWidth = newWidth;
    }
  }, 500);

  function forceFullWidth($headerOffsetElem) {
    var $container;

    if ($headerOffsetElem && $headerOffsetElem.length) {
      $container = $('.content-wrapper.container');

      if ($container.length) {
        $container.removeClass('container');
        theme.RS.OffsetHeader.offsetHeader($headerOffsetElem);
      }
    }
  }

  function initForceFullWidth($headerOffsetElem) {
    if ($headerOffsetElem && $headerOffsetElem.length) {
      forceFullWidth($headerOffsetElem);

      theme.cached.$window.on('resize', function() {
        debounceForceFullWidth($headerOffsetElem);
      });
    }
  };

  return {
    initForceFullWidth: initForceFullWidth,
    forceFullWidth: forceFullWidth
  };

})();

window.RS.JQueryAccordion = (function() {
  const Public = {};
  const selectors = new Set();
  const FLAG_VAR = 'jqueryAccordion';

  Public.loadScript = function(cb, args) {
    const src = window.theme?.strings?.jqueryAccordionSrc;
    const jqueryAccordion = window.RS?.variables[FLAG_VAR];
    let scripts = [];

    if (src) {

      if (!jqueryAccordion) {
        scripts = Array
          .from(document.querySelectorAll('script'))
          .map(scr => scr.src);
      }

      if (!jqueryAccordion && !scripts.includes(src)) {
        let scriptElem = document.createElement('script');
        scriptElem.defer = true;
        scriptElem.src = src;
        scriptElem.type = "text/javascript";
        document.body.appendChild(scriptElem);

        if (cb && typeof(cb) === 'function') {
          scriptElem.onload = function() {
            cb(...args);
          };
        }

        window.RS.variables[FLAG_VAR] = true;

        return true;
      } else {

        if (cb && typeof(cb) === 'function') {
          cb(...args);
        }
      }
    }
  };

  Public.initAccordion = function(opts) {
    if (opts.selector && !selectors.has(opts.selector)) {
      const $elem = $(opts.selector);
      selectors.add(opts.selector);

      if ($elem.length && $elem.accordion) {
        $elem.accordion({
          defaultOpen: opts.defaultOpen,
          cookieName: opts.cookieName
        });
      }
    }
  };

  Public.init = function(opts) {
    Public.loadScript(Public.initAccordion, [opts]);
  };

  return Public;
})();

window.RS = window.RS || {};

window.RS.Helpers = window.RS.Helpers || {};

window.RS.Helpers.beadPartyTextReplace = function(opts = {}) {
  let replaced = opts.value;
  let newValue;
  let defaultClass = window.theme?.strings?.beadPartyReplaceDefaultClass || 'uppercase tracking-1 inline-block leading-inherit rs-skip-auto-find-replace';
  let wrapperClass = opts.wrapperClass ? `${defaultClass} ${opts.wrapperClass}` : defaultClass;

  if (opts.value) {
    newValue = `<span class="${wrapperClass}"`;
    if (opts.wrapperStyles) {
      newValue += ` styles="${opts.wrapperStyles}"`;
    }
    newValue += `${newValue}>BEAD Party</span>`
    replaced = opts.value.replace(/bead party/ig, newValue);
  }

  return replaced;
}

window.RS.Helpers.getHeaderHeight = function() {
  var $header = theme.cached.$header || $('#shopify-section-header');
  var headerHeight = $header.outerHeight();
  // Height of header content
  var headerContentHeight = $('.homepageheader_border', $header).outerHeight();
  var totalHeight = headerContentHeight - headerHeight;

  return totalHeight;
}

/*******************************************************************************
 * RS NAVIGATOR
 *******************************************************************************/
//TODO: add history in a way that seems natural. Everything? only pagination clicks?
//eventually: be able to run more than one on a page. Not currently a need, but with a passed in collection url, and (root).find for the lookups, is possible and unique to shopify, or ecommerce in general.
theme.rs_navigator = function(collection_name, PRODUCTS_PER_PAGE, PRODUCT_RENDERER, CUSTOM_FILTERS, CUSTOM_FILTERS_STRINGS, filter_generator) {
  //TODO: find the one with the HOME var?
  const PRODUCTS_PER_AJAX = 100;//this has to be in sync with collection.json.liquid
//TODO: if you expect a full page of items, and the count is not this number, do some sort of error message.
//TODO: can it not take 100? RR got changed to 50.

  // GLOBAL VARIABLES:
  var allProducts = [],     // all products in the collection/page
    sortParam = '',
    rs_filter = theme.rs_filter($('#filtermenu'), CUSTOM_FILTERS, false);
  //rather than constantly querying these, set it and forget it
  var gparams = {
    page: 1,
    q: undefined,//might override these off the url
    filterOptions: undefined,
    sortBy: undefined
  };

//random functions
  function splitParams(url) {
    if (!url) url = window.location.href;//.search would be shorter
    var parms= url.split('?'),
      out = [];
    if (parms.length != 2) {
      return out;
    }
    var a = parms[1].split('&');
    for (var i = 0; i < a.length; i++) {
      var _  = a[i].split('=');
      out[_[0]] = _[1];
    }
    return out;
  }

  function pushState() {
    var params = { }, needsparams = false;
    if (gparams.page != 1) {
      params.page = gparams.page;
      needsparams= 1;
    }
    if (gparams.q) {
      params.q = gparams.q;
      needsparams = 1;
    }
    var url = location.pathname;
    //null/'' are ignored, meaning it won't replace an existing ?page
    if (needsparams) {
      url = "?" + $.param(params);
    };
    history.pushState(
      {
        filterOptions: gparams.filterOptions
      },
      ' ',//title, ignored
      url
    );
  }


//PAGINATION DIV

  function pagination_init() {
    $("#pagination").on('click', 'a',function (e) {
      e.preventDefault();
      var page = $(this).attr('title')
      if (page === '') {
        page = '999';
      }
      if (page !== '999') {
        page = parseInt(page);
        $("html, body").animate({ scrollTop: 0 }, 500);//might also go to product-loop
      }
      if (page != gparams.page) {
        gparams.page = page;
        pushState();
      }
      paginateProducts(page);
    });
  }
  function setPaginator(currPage) {
    if (1 >= totalPages) {
      $('.rs-pagination').html('');
      return;
    }
    var paginator = "";
    if (currPage !== '999') {
      paginator +=
        ((currPage - 1 >= 1) ? '<a href="/collections/' + collection_name + '?page=' + (currPage - 1) + '" title="' + (currPage - 1) + '">Prev</a>' : '')
        + ((currPage !== 1) ? '<a href="/collections/' + collection_name + '?page=1" title="1">1</a>' : '' )
        + ((currPage >= 4) ? '…' : '')
        + ((currPage - 2 > 1) ? '<a href="/collections/' + collection_name + '?page=' + (currPage - 2) + '" title="' + (currPage - 2) + '">' + (currPage - 2) + '</a>' : '' )
        + ((currPage - 1 > 1) ? '<a href="/collections/' + collection_name + '?page=' + (currPage - 1) + '" title="' + (currPage - 1) + '">' + (currPage - 1) + '</a>' : '' )
        + '<span class="current">' + currPage + '</span>'
        + ((currPage + 1 < totalPages) ? '<a href="/collections/' + collection_name + '?page=' + (currPage + 1) + '" title="' + (currPage + 1) + '">' + (currPage + 1) + '</a>' : '' )
        + ((currPage + 2 < totalPages) ? '<a href="/collections/' + collection_name + '?page=' + (currPage + 2) + '" title="' + (currPage + 2) + '">' + (currPage + 2) + '</a>' : '' )
        + ((currPage <= totalPages - 4) ? '…' : '')
        + ((currPage !== totalPages) ? '<a href="/collections/' + collection_name + '?page=' + totalPages + '" title="' + totalPages + '">' + totalPages + '</a>' : '' )
        + ((currPage + 1 <= totalPages) ? '<a href="/collections/' + collection_name + '?page=' + (currPage + 1) + '" title="' + (currPage + 1) + '">Next</a>' : '');
    }
    //TODO: decide if it is worth showing view all if there are more that X total pages. See also NN.
    if (totalPages <= 10 && currPage !== '999') {
      paginator += '<a href="/collections/' + collection_name + '?page=' + (currPage === '999' ? "1" : '999' ) + '" title="">' + (currPage === '999' ? theme.strings.vless : theme.strings.vall ) + '</a>';
    }
    $('.rs-pagination').html(paginator).show();
  }

  function getPage(page) {
    gparams.page = page;
    pushState();
    paginateProducts(page);
  }



// FILTERING

  function unsetFilterOption(ukey, uval) {
    if (gparams.filterOptions == undefined) return;
    rs_filter.unsetFilterOption(gparams.filterOptions, ukey, uval);
  }

  function setFilterOptions(options) {
    // sort by:
    if(options.sortBy) {
      $('select#SortBy').val(options.sortBy);//TODO: css, there's no sort by in the liquid
    }
    //TODO: search?
    if (options.filterOptions == undefined) return;
    // filter options:
    rs_filter.setFilterOptions(options.filterOptions);

    filtershown(options.filterOptions);
  }

  /** basic word matching search function
   */
  function searchText(qs, object) {
    return true;
    //IE (not edge) doesn't support this at all. worry about that later
    /*
    if (!qs.find) return true;
    return (qs.find((q)=>object.title.includes(q))!==undefined) && (qs.find((q)=>object.description.includes(q))!==undefined)
    (object.variants && object.variants.length &&
      qs.find((q)=>
        object.variants.find((v)=>v.title.includes(q))!==undefined
      ) &&
      (object.tags && object.tags.length &&
        qs.find((q)=>
          object.tags.find((t)=>tincludes(q))!==undefined
        )
      )
    )
    ;*/
  }





// HISTORY STATE


  var filterProducts = function(data) {
    var filters = gparams.filterOptions,
      output = rs_filter.filterProducts(data, filters);
    //use gparams.q to further reduce output.
    //Better: given that q is probably coming from the actual shopify search, this should probably only be used instead with a secondary filter-search.
    //would need to add that to setParam, gparams. Get business case first. Could be confusing with 2 different search options.
    if (false && gparams.q) {
      //need that as an array
      var output2 = [], qs = gparams.q.split(/\W+/);
      for (var i = 0; i < output.length; i++) {
        if (searchText(filters, output[i])) {
          output2.push(qs, output[i]);
        }
      }
    }
    //Would need to be nearly as useful as the built-in search, but would allow for better cached data.
    //Might also be able to: search by price ranges, variants without tags (does shopify do that?)
    return output;
  }



//PRODUCTS

  function product_init() {
    $('#product-loop').on('click', '.grid__item a', function() {
      //save the div id as the scroll state, instead of the pixels
      let state = history.state || {};
      state.scrollTo = $(this).closest('.grid__item').attr('id');
      history.replaceState(state, '', location.href);//TEST: that the div works the same as the scrollTop()
    });
    $('select#SortBy').on('change', function(){
      gparams.sortBy = $(this).val();
      paginateProducts(gparams.page);
    });
  }
  function product_sort(products) {
    var sortf = 0;
    if (gparams.sortBy == 'title-descending')
      sortf = function (b,a) { return a.title.localeCompare(b.title)}
    else if (gparams.sortBy == 'title-ascending')
      sortf = function (a,b) { return a.title.localeCompare(b.title)}
    else if (gparams.sortBy == 'price-ascending')
      sortf = function (a,b) { return a.variant[0].price - b.variant[0].price}//handle/product.json does not return a product price
    else if (gparams.sortBy == 'price-descending')
      sortf = function (b,a) { return a.variant[0].price - b.variant[0].price}
    else if (gparams.sortBy == 'created-ascending')
      sortf = function (a,b) { return (a.published_at >b.published_at  ? -1 : (a.published_at ==b.published_at  ? a.title.localeCompare(b.title) : 1)); }
    else if (gparams.sortBy == 'created-descending')
      sortf = function (b,a) { return (a.published_at >b.published_at  ? 1 : (a.published_at ==b.published_at  ? a.title.localeCompare(b.title) : -1)); }

    //else return natural, collection defined sort
    if (sortf)
      products.sort(sortf)
  }
  function paginateProducts (page) {
    products = filterProducts(allProducts);
    product_sort(products)
    totalPages = Math.ceil(products.length / PRODUCTS_PER_PAGE);
    $("#num-products").html("("+products.length+") items");

    //live filter update
    //rs_filter.restrictFilterOptions(products);

    if (products.length > 0 && page) {

      if (page !== '999' && page > totalPages) {//TEST: the ==='' bit
        page = 1;
        //may need to reset the url here: was page 2, filter reduced that to 1 page, url is still page=2
      }
      var endNdx = ( (products.length < (page * PRODUCTS_PER_PAGE)) || (page === '999') ) ? products.length : page * PRODUCTS_PER_PAGE;//is either all available products, or a single page
      var productGrid = '';
      var startIdx = (page === '999' || (endNdx < PRODUCTS_PER_PAGE)) ? 0 : (page - 1) * PRODUCTS_PER_PAGE;//is either 0, or the start of the page
      for (var i=startIdx; i < endNdx; i++ ) {
        productGrid += PRODUCT_RENDERER.renderGrid(i, products[i], gparams.filterOptions);
      }
      // render HTML
      $('#rs-notfound').hide();
      $("#product-loop").html(productGrid).removeClass('no-results').show();
      setPaginator(page);
    } else {
      $('#rs-notfound').show();
      $('#pagination').hide();
      $("#product-loop").hide();
    }
    //document.dispatchEvent(new CustomEvent('rs-navigator.paginator'))
    $(document).trigger('rs-navigator.paginator', [page])
  }


//document.addEventListener('rs-filter.change', function() {
  $(document).on('rs-filter.change', function(e) {

    gparams.filterOptions = rs_filter.fillFilter();
    filtershown(gparams.filterOptions);
    if (gparams.page != '999') { gparams.page = 1; }
    //replace state for each filter change?
    //also, the original version did not reset the page number
    paginateProducts(gparams.page);

    //reset the url to reflect the new filters.
    //ideally, make this a separate bit so that you can deploy the filter more than once per page, or on pages where it shouldn't update the url
    //D had individual elements, but this abuses the pre-existing search fuction, hopefully looks cleaner, too.
    var q = Object.keys(gparams.filterOptions).map(function(o){return gparams.filterOptions[o].map(function(o){return encodeURIComponent(o)}).join(',')}).join(',');
    if (q) {
      q = location.pathname + '?q='+q;
    } else {
      q = location.pathname;
    }
    history.replaceState(gparams, 'Filtered', q);
  });

  function filtershown(filterOptions) {
    //generate another list of shows filters
    var $filtershown = $('#filtershown');
    if ($filtershown.length === 0) {
      return
    }
    $filtershown.html('');
    var defaultString = function(ortag) {
      return ortag;
    }
    $.each(filterOptions, function (key, ortags) {
      var _ = CUSTOM_FILTERS_STRINGS[key] || defaultString;
      $.each(ortags, function(i,ortag) {

        $filtershown.append('<li class="clear-filter-item" data-block="'+key+'" data-tag="'+
          ortag+'"><a>'+
          _(ortag)+'</a><span class="ion-close-round"></span></li>');
      });
    });
  }








  function pageInit() {
    //a way to drop products. I know this is terrible system design, (because it's public data.
    // hiding it doesn't make it secret) but 2 people have asked for it.
    // might filter out .available or tags==wholesale.
    if (PRODUCT_RENDERER.filterProduct) {
      var tmp = [];
      $.each(allProducts, function (i,o){
        if (PRODUCT_RENDERER.filterProduct(o)) {
          tmp.push(o);
        }
      });
      allProducts = tmp;
    }

    setFilterOptions(gparams);
    paginateProducts(gparams.page);

    if (history.state && history.state.scrollTo) {
      var $scroll = $('#'+history.state.scrollTo);
      if ($scroll.length == 1) {
        //$('#product-loop').imagesLoaded().done( function( instance ) {
        $('html, body').animate({ scrollTop: $scroll.offset().top }, 700);
        //});
      }
    }

    if (!filter_generator) {
      rs_filter.restrictFilterOptions(allProducts);
    }
  }

  function postload() {
    if (filter_generator) {
      filter_generator(allProducts);
    }
    pagination_init();
    product_init();

    if (gparams.q && history.state.scrollTo) {
      //Prob: scrollTo needs it filtered first
      //But if the products are generating the filters, the filters won't exist here.
      //might need to break up the pageInit function.
      rs_filter.searchToFilter(gparams.q.split(',').map(function(x){return decodeURIComponent(x)}));
      gparams.filterOptions = rs_filter.fillFilter();
    }
    pageInit();

    //run this after the filter_generator
    if (gparams.q) {
      rs_filter.searchToFilter(gparams.q.split(',').map(function(x){return decodeURIComponent(x)}));
      $(document).trigger('rs-filter.change');
    }
    $("#num-products").html("("+allProducts.length+") items");
    $(document).trigger('rs-navigator.loaded');
  }

  function finishAjax() {
    postload();
    $('#ajaxLoader').hide();
  }

  function loadDataAPI(collection_id, c) {
    /*
    I didn't forget about this.
    Pros: is faster.
          has better interal caching (not sure why, though)
          automatically includes img, variant data
    Cons: requires modifying the collection's sales channels, private app
          is under active development. Documentations and options are not in sync
          does not return all items, anyway
          does not return totals, so it would have to get that from liquid, or keep asking until it gets less than 50.
          does not work with search strings
          does not include metafields

    https://help.shopify.com/api/storefront-api/getting-started
    http://www.codeshopify.com/blog_posts/the-javascript-sdk-part-1-displaying-products-on-an-external-site
    Add to theme:
    <script src="http://sdks.shopifycdn.com/js-buy-sdk/v0/latest/shopify-buy.umd.min.js" async="async" defer="defer"></script>
    (There's also a http://sdks.shopifycdn.com/js-buy-sdk/v0/latest/shopify-buy.umd.polyfilled.min.js
    I don't know what exactly the polyfill brings support down to, or if we still care about IE or old android)

    Add the setup to theme.liquid's site setup script:
    const shopClient = ShopifyBuy.buildClient({
        accessToken: 'efc42042e279a181b5d1e8c34313728f',
        domain: 'roswelldev.myshopify.com',
        appId: '6'
    })
    //The 6 may change. (first app?) I don't see how to get the real id.
    //access token is from creating a private app.
    */
//setup global shopClient in theme.liquid
    if (typeof shopClient === 'undefined') {
      console.log('%cNOTE: the Collection page used the API method, but did not set up the shopClient','color: red; font-size: x-large')
      return;
    }
    var pagesCount = Math.ceil(c / PRODUCTS_PER_AJAX);

    var requests = [];
    for (var i = 1; i<= pagesCount; i++) {
      let page = i;
      requests.push(
        shopClient.fetchQueryProducts({
          'collection_id': collection_id,
          'limit':PRODUCTS_PER_AJAX,
          'page': page
        }).then(function(products) {
          for (var j = 0; j < products.length; j++) {
            allProducts[((page - 1) * PRODUCTS_PER_AJAX) + j] = items[j];
          }
        })
      );
    }
    $.when.apply($, requests).done(function() {
      allProducts = allProducts.filter(function(v, i) {
        return v ? v : null;
      });
      finishAjax();
    });
  }

  function loadDataAsset(url) {
    $.get(url,function(data) {
      allProducts = JSON.parse(data);
      finishAjax();
    })
  }
//var preloaded_page = 0;
  function loadDataJSON(productsCount, search_terms) {

    var pagesCount = Math.ceil(productsCount / PRODUCTS_PER_AJAX),
      search = '',
      //PROGRAMMER: pick one of these
      //view = "view=metafields&page=";//includes metadata
      view = "view=json&page=";//slightly simpler
    //TODO: need to be able to select this in the collection page.
    // - also, search?
    //TODO: does the pathname contain /tag? Could be very confusing, shouldn't

    //TODO: alt: use /collections/handle/products.json
    // - a lot of people hate that it reveals all their info, it doesn't seem to be documented.
    // + seems to be faster.

    if (search_terms) {
      search = 'view=json&q='+ escape(search_terms) + '&type=product&'
      //note: far less likely to be cached. Ideally, do the search internally.
    }//TEST:search url
    var baseUrl = location.pathname + '?' + search + view;

    totalPages = Math.ceil(productsCount / PRODUCTS_PER_PAGE);

    if (gparams.sortBy) {
      sortParam = '&sort='+gparams.sortBy;
    }

    //INIT VIA AJAX:
    var requests = [];

    for (var i = 1; i<= pagesCount; i++) {
      // if (preloaded_page === i) {
      //  continue;
      // }
      //problem: the "paginate collection.products by" needs to match the page size in collection.json
      // for preload to save a JSON load
      // but if it is 100 all the time, the liquid pagination stops working as intended
      // what I need is to get the correct "page" the slice lives on
      // --could also be split across "pages"
      //--more trouble that it is worth to save 1 ajax load, given that the preload works correctly.


      let page = i;
      requests.push(
        //TODO: I want this to be cached, but doesn't seem to be. The api calls are cached. Some apps hack xhr, too.
        //There's window.fetch, which is what the api call is using, but it didn't seem to work. either.
        // Maybe? I note the size is much smaller, but it doesn't say "from memory"
        // also not supported in IE without the polyfill
// fetch(baseUrl + page + sortParam,{
//   credentials: 'same-origin'  //probably don't actually need this?
// }).then((res)=>res.json()).then((items)=>{
// for (var j = 0; j < items.length; j++) {
//   allProducts[((page - 1) * PRODUCTS_PER_AJAX) + j] = items[j];
// }
// }});
//fetch also always returns, which is nice.
        $.get(baseUrl + page + sortParam, function(data) {
          var items = JSON.parse(data);
          for (var j = 0; j < items.length; j++) {
            allProducts[((page - 1) * PRODUCTS_PER_AJAX) + j] = items[j];
          }
        })
      );
    }

    $.when.apply($, requests).done(function() {
      allProducts = allProducts.filter(function(v, i) {
        return v ? v : null;
      });
      finishAjax();
    });
  }


  window.addEventListener('popstate', function(e) {
    console.log(e, 'running?!?')
    //popstate does not trigger on initial page load
    if(e.state) {
      console.log(e);
      gparams = e.state;
      pageInit();
    }
  });



//init has available to it only the variables passed in, and the page url
// should not actually do anything

  function navinit() {
    var ps = splitParams();
    if (ps.q) {
      gparams.q = ps.q
    }
    if (ps.page) {
      gparams.page = parseInt(ps.page)
    }
    //get the tags off the url? Will be in the setFilter/popstate, but would be nice for a reload
  }


  navinit();
  return {
    'find':function (fn) {
      return allProducts.find(fn);
    },
    'loadDirectly':function(products, current_page) {
      allProducts = products;
      gparams.page = parseInt(current_page)

      //render 1 page, assuming liquid did all filtering.
      //Do not override the anchors, let it go back to Shopify
      //Maybe? set the pagition anchors to grab the products[] JSON out of the page render?
      // reset allProducts, the page number, then re-render. Faster than re-loading the entire page.

      pageInit();
    }
    ,
    'loadRemotely':function(src, asset_url, total_products, search_count) {
      $('#ajaxLoader').show();
      //start the load the data from the url(s)
      //Init the anchor overrides
      if (src === 'json') {
        loadDataJSON(parseInt(total_products||search_count), gparams.q)
      } else {
        loadDataAsset(asset_url)
      }
    }
    ,
    'loadAPI':function(collection_id, count_of_collection) {
      $('#ajaxLoader').show();
      loadDataAPI(collection_id, count_of_collection);
    }
    ,
    /**
     Need to call this first in order get the ajax call's filter options set up correctly
     */
    'setFiltering':function(tags, search){
      //filterOptions is an array (and-level) of arrays (or-level) of items.
      if (tags) {
        if (!(tags instanceof Array)) {
          gparams.filterOptions = tags;
        } else {
          //Tags is an array of options, but not attached to any particular and-level. Throw them at all the or-level options.

          setTimeout(function(){//bg this
            rs_filter.searchToFilter(tags);
          },3);
        }
      }

      if (search) {
        //automagically select any search terms.

        setTimeout(function(){//bg this
          rs_filter.searchToFilter(search.split(/\W+/));
        },3);
      }
      gparams.q = search;

      //setFilterOptions(gparams);
      //filtershown(gparams.filterOptions);
    }
    ,
    'setView': function (all) {
      if (all) {
        gparams.page = '999';
      } else {
        gparams.page = 1;
      }
      paginateProducts(gparams.page);
    }
    ,
    /**
     if you are looking at a page, dump that content directly and not wait for the ajax calls.
     //render that content. Assuming there's no custom sort ordering or filtering in place yet, it will be the real content. (so the ajax load is only waiting on the other pages' data, and the pagination.)
     //Prob: The ajax will eventually finish and call the same functions. Some (click inits) need to not be called twice.
     - Don't want this rendering to slow down starting the ajax load. (Might want to make this an add-on to remote, so it knows to skip the page, start theload, then process the data it has while it waits)
     */
    'preload': function (items, page) {
      //this is getting a bit messy, especially with pagination>1
      //but at least don't ever show filtered products.
      if (PRODUCT_RENDERER.filterProduct) {
        var tmp = [];
        $.each(items, function (i,o){
          if (PRODUCT_RENDERER.filterProduct(o)) {
            tmp.push(o);
          }
        });
        items = tmp;
      }
      for (var j = 0; j < items.length; j++) {
        allProducts[((page - 1) * PRODUCTS_PER_PAGE) + j] = items[j];//note: _PER_PAGE, not _PER_AJAX. This uses the shopify pagination number.
      }
      gparams.page = parseInt(page);
      gparams.filterOptions = gparams.filterOptions||{};
      if (gparams.filterOptions.q) {
        rs_filter.searchToFilter(gparams.filterOptions.q.split(','));
      }
      paginateProducts(gparams.page);//TODO this will happen twice with postload
    },
    'postload': postload
  }
}
//TODO: test the "bg this" lines actually improve anything with a complicated page layout
//Ideally, rework all this so that the ajax setup occurs before any additional processing.
//- is currently the searchToFilter dom loops, the preload page layout (which, with an ajax loader, is entirely cosmetic!)
//- might reduce this to 1 function call, but with more params.
/*things are boiling down to:
accept the page data, show it now for snappy UI.
 - Ideally, hover, quickview, click, work at this point.
 - but not paginate or filter (maybe? If you click the filter, the filter options would be set for the main load).
 - it would be doubled work, but just rendering html in liquid is certainly good here.
 - - rendering all the html in liquid would make random filtering harder, but is do-able.
 - - certainly if you add data-tags={{tags}} data-price={{price}}
accept the filtering options, setup dom.
 is only really costly if there are filter options.
 (there's always a collection tag for liquid cached system)
 (tags, search, url (todo: pull more out of url, like /collections/spoopy?priceRange=2,3))
 -related: there's no way to bookmark advanced/non-shopify filter searches
 the page data already reflects filtering options, presumably
  but not if there are url based options.
if necessary start ajax loading product list
-wait for ajax loader
-if there's no flash or loss of hover status, could redraw after each ajax call
- also: quickview
filter product list
display page of products
 ideally the same list as the live page from point 1. might want to check to save dom redraw.
display pagination
 is usually offscreen, anyway.
Restrict available filter options to products
 -if this gets called on partial load, make sure it doesn't remove options.

*/

/*******************************************************************************
 * END RS NAVIGATOR
 *******************************************************************************/


/*******************************************************************************
 * Perform on document ready
 *******************************************************************************/

$(function() {

  // Trigger event that theme.js is done loading
  if (theme.finish_loading) {
    theme.finish_loading();
  }
  $(document).trigger('loaded.theme');

  // Add body, header, & footer elements to cached elements object
  theme.cached = theme.initCachedElems({
    body: 'body',
    header: '#shopify-section-header',
    footer: '#shopify-section-footer'
  }, null, theme.cached);

  theme.RS.OffsetHeader.initOffsetHeader('.template__offset-header');
  theme.RS.ForceFullWidth.initForceFullWidth($('.template__full-width'));
  theme.RS.OffsetTransparentHeader.init();
  theme.RS.HeaderScroll.init();
});


// bridal page sliders
$(function() {
  var arrow = '<?xml version="1.0" encoding="UTF-8"?><svg xmlns="http://www.w3.org/2000/svg" width="16" height="28" viewBox="0 0 8 14"><path id="b" d="m7.25,1L1.25,7l6,6" fill="none" stroke="currentColor" stroke-width="1"/></svg>'
  var prevArrow = '<button type="button" class="slick-prev pull-left">' + arrow + '</button>';
  var nextArrow = '<button type="button" class="slick-next pull-right">' + arrow + '</button>';
  var $mini = $('.mini-carousels');
  var breakpoints = {
    mobile: 767,
    desktop: 1199
  }

  if ( $mini.length > 0 ) {
    $mini.each(function() {
      var index = $(this).data('index');
      $(this).on('init reInit afterChange', function(event, slick) {
        var $current = $(this).find('.slick-dots .slick-active');
        var $dots = $(this).find('.slick-dots li');
        var max = $dots.length;
        var current = $dots.index($current);

        for ( var i = 0; i < max; i++ ) {
          var delta = current - i;
          $dots.eq(i).removeClass('sibling-one sibling-two current');
          switch (Math.abs(delta)) {
            case 0:
              $dots.eq(i).addClass('current');
              break;
            case 1:
              $dots.eq(i).addClass('sibling-one');
              break;
            case 2:
              $dots.eq(i).addClass('sibling-two');
            default:
          }
        }
      });

      $(this).slick({
        lazyLoad: 'ondemand',
        initialSlide: (typeof index === 'number') ? index: 0,
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: false,
        arrows: false,
        dots: true,
        mobileFirst: true,
        responsive: [
          {
            breakpoint: 767,
            settings: {
              prevArrow: prevArrow,
              nextArrow: nextArrow,
              arrows: true,
              // dots: false, experiments
              dots: true
            }
          }
        ]
      });
    });
  }

  // pdp
  var THRESHOLD = 4;
  var MOTIONLESS = 'motionless';
  var trackEl = '.slick-track';
  var slideEl = '.pdp.slider-for';
  var navEl = '.pdp.slider-nav';
  var imagesEl = [slideEl, '.image__container'].join(' ');
  var navTracks = [navEl, trackEl].join(' ');
  var motionless = false;
  var pdpIndex = $('.slider-nav').data('index');
  var intialSlide = (typeof pdpIndex === 'number') ? pdpIndex: 0;
  var threshold;
  var slideSettings = {
    swipe: true,
    initialSlide: intialSlide,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: false,
    asNavFor: navEl,
    mobileFirst: true,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          swipe: false,
          arrows: true,
          prevArrow: prevArrow,
          nextArrow: nextArrow
        }
      }
    ]
  };
  var navSettings = {
    lazyLoad: 'ondemand',
    initialSlide: intialSlide,
    slidesToShow: 3,
    slidesToScroll: 1,
    asNavFor: slideEl,
    dots: false,
    prevArrow: prevArrow,
    nextArrow: nextArrow,
    arrows: true,
    focusOnSelect: true,
    mobileFirst: true,
    responsive: [
      {
        breakpoint: breakpoints.mobile,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: breakpoints.desktop,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          arrows: false,
        }
      }
    ]
  }

  var desktop = `(min-width: ${breakpoints.desktop}px)`;
  var mq = window.matchMedia(desktop);
  if ( mq.matches ) {
    threshold = 4;
  } else {
    threshold = 3;
  }
  var $imagesEl = $(imagesEl);
  var $slideEl = $(slideEl);
  var $navEl = $(navEl);
  var numberImages;

  if ( $imagesEl.length ) {
    numberImages = $imagesEl.length;
    if ($imagesEl.length > threshold ) {
      navSettings.centerMode = true;
      navSettings.centerPadding = 0;
    } else {
      motionless = true;
    }
    $slideEl.slick(slideSettings);
    $navEl.on('init reInit', function(event, slick, currentSlide, nextSlide) {
      if ( motionless ) {
        $(navTracks).addClass(MOTIONLESS);
      }
    });
    $navEl.slick(navSettings);


    // form event listener
    var onChange = function(e) {
      var payload = e.detail;

      if ( payload && payload.variant ) {
        var variant = payload.variant;

        $imagesEl.each(function(index) {
          var $img = $('[data-image-id="' + variant.featured_image.id + '"]', $(this));
          // check to disregard cloned slides
          if ( $img.length && index < numberImages ) {
            var nextSlide = $img.data('index');
            if ( typeof nextSlide === 'number' ) {
              $navEl.slick('slickGoTo', nextSlide);
            }
          }
        });
      }
    }
    document.addEventListener('change:selected', onChange);
  }

});

// $(document).ready(function () {
//   // Initially hide all containers
//   $('.container').hide();
//
//   // Add click event to accordion titles
//   $('.accordion').click(function () {
//     // Hide all containers
//     // $('.container').hide();
//     $(this).toggleClass('accordion-open');
//
//     // Show the container immediately after the clicked title
//     $(this).next('.container').toggle('hide');
//   });
// });

// customer care
$(document).ready(function () {
  $('.customer-care .container').hide();
  // Add click event to accordion titles
  $('.customer-care .accordion').click(function () {
    // Toggle the visibility of the clicked container
    $(this).next('.customer-care .container').slideToggle(400);

    // Toggle the class for the clicked accordion
    $(this).toggleClass('accordion-open');

    // Hide other containers and remove the class from other accordions
    $('.customer-care .container').not($(this).next('.container')).slideUp(400);
    $('.customer-care .accordion').not(this).removeClass('accordion-open');
  });
});


